<div class="fw-bold mb-2">{{ 'Gespeicherte Suchformulare' | translate }}</div>
<div class="d-flex align-items-center gap-2">
  <dx-select-box class="flex-fill"
                 [dataSource]="allSearchForms"
                 displayExpr="name"
                 [(value)]="selectedSearchForm"
                 [showClearButton]="true"
                 placeholder="{{ 'Suchformular auswählen...' | translate }}">
  </dx-select-box>
  <dx-button icon="icon-glyphicons-basic-82-refresh"
             type="default"
             stylingMode="text"
             [disabled]="!selectedSearchForm"
             hint="{{ 'Suche ausführen' | translate }}"
             (onClick)="executeSearchForm()">
  </dx-button>
  <dx-button icon="edit"
             type="default"
             stylingMode="text"
             hint="{{ 'Suchformular editieren' | translate }}"
             (onClick)="editSearchForm()">
  </dx-button>
  <dx-button icon="save"
             type="default"
             stylingMode="text"
             [disabled]="!selectedSearchForm"
             hint="{{ 'Suchformular speichern' | translate }}"
             (onClick)="saveSelectedSearchForm()">
  </dx-button>
</div>
